import {
  DrawerBody,
  Flex,
  FormControl,
  FormHelperText,
  FormLabel,
  Select,
  Stack,
  Text,
} from '@chakra-ui/react';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { TotalBadge } from '../atoms/SummaryBadge';
import { useCreateContractModalContext } from '../modals/CreateContractModal/ModalContext';
import ContractModalFooter from '../molecules/ContractModalFooter';

interface PaymentStepProps {
  onClose: () => void;
  onNext?: () => void;
}

const PaymentStep: React.FC<PaymentStepProps> = ({ onClose, onNext }) => {
  const {
    nextStep,
    paymentDay,
    setPaymentDay,
    paymentMethod,
    setPaymentMethod,
    addedProducts,
  } = useCreateContractModalContext();
  const [dayTip, setDayTip] = useState('');

  const paymentDays = [5, 10, 15, 20];

  const getValidPaymentDay = (paymentDay: number) => {
    const validDays = [5, 10, 15, 20];
    for (const day of validDays) {
      if (paymentDay <= day) {
        return day;
      }
    }
    return 5;
  };

  const updateDayTip = useCallback(() => {
    const today = new Date().getDate();
    const payDate = new Date();

    if (paymentDay) {
      payDate.setDate(getValidPaymentDay(paymentDay));

      if (Number(paymentDay) < today) {
        payDate.setMonth(payDate.getMonth() + 1);
      }
    }

    setDayTip(
      `Primeira cobrança dia ${payDate.toLocaleString('pt', {
        day: 'numeric',
        month: 'long',
      })}`,
    );
  }, [paymentDay]);

  const handleNext = () => {
    (onNext ?? nextStep)();
  };

  useEffect(() => {
    updateDayTip();
  }, [updateDayTip]);

  const total = useMemo(() => {
    return addedProducts.reduce((sum, product) => {
      if (product.discount?.product_value_with_discount != null) {
        return sum + product.discount.product_value_with_discount;
      }
      const serviceValue = product.selectedService?.value;
      return sum + (typeof serviceValue === 'number' ? serviceValue : 0);
    }, 0);
  }, [addedProducts]);

  return (
    <Flex direction="column" flex={1} minH={0} overflow="hidden">
      <DrawerBody scrollBehavior="auto" pb="0">
        <Stack py="1rem" minH="100%" spacing={8} px={2}>
          <Flex justify="space-between" align="center">
            <Text fontWeight="semibold" fontSize="1.25rem">
              Qual a forma de pagamento e dia do vencimento?
            </Text>
            <TotalBadge total={total} />
          </Flex>

          <FormControl mb="1rem">
            <FormLabel htmlFor="select-payment-method">
              <Text fontWeight="semibold" fontSize="1rem">
                Forma de pagamento:
              </Text>
            </FormLabel>
            <Select
              id="select-payment-method"
              value={paymentMethod}
              onChange={(e) =>
                setPaymentMethod(Number(e.target.value) as 1 | 2)
              }
            >
              <option value="1">Cartão de Crédito</option>
              <option value="2">Boleto Bancário</option>
            </Select>
          </FormControl>

          <FormControl>
            <FormLabel htmlFor="select-due-date">
              <Text fontWeight="semibold" fontSize="1rem">
                Dia do vencimento:
              </Text>
            </FormLabel>
            <Select
              id="select-due-date"
              value={paymentDay}
              onChange={(e) => setPaymentDay(Number(e.target.value))}
            >
              {paymentDays.map((day) => (
                <option key={day} value={day}>
                  {day}
                </option>
              ))}
            </Select>
            <FormHelperText>{dayTip}</FormHelperText>
          </FormControl>
        </Stack>
      </DrawerBody>

      <ContractModalFooter onCancel={onClose} onNext={handleNext} />
    </Flex>
  );
};

export default PaymentStep;
